import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import * as uuid from 'uuid';

@Injectable({ providedIn: 'root' })
export class KeycloakOAuthService extends OAuthService {
  protected storeAccessTokenResponse(
    accessToken: string,
    refreshToken: string,
    expiresIn: number,
    grantedScopes: string
  ) {
    super.storeAccessTokenResponse(
      accessToken,
      refreshToken,
      expiresIn,
      grantedScopes
    );
    this.notifyStorageUpdate();
  }

  public logOut() {
    super.logOut();
    this.notifyStorageUpdate();
  }

  private notifyStorageUpdate() {
    // Signal that the auth data is updated only after __all__ auth-related fields are written to the storage.
    this._storage.setItem('auth_data_updated', uuid.v4());
    this._storage.removeItem('auth_data_updated');
  }
}
